module.exports = __webpack_public_path__ + "img/partner-7.ea9dffe7.png";